import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { EASE, Reveal } from "./ui-bits";

export default function Faq({ items }) {
  const [open, setOpen] = useState(0);
  return (
    <div className="border-t border-line" data-testid="faq-accordion">
      {items.map((f, i) => {
        const isOpen = open === i;
        return (
          <Reveal key={f.q} delay={i * 0.04} className="border-b border-line">
            <button
              onClick={() => setOpen(isOpen ? -1 : i)}
              className="w-full flex items-start justify-between gap-6 py-6 text-left group"
              aria-expanded={isOpen}
              data-testid={`faq-question-${i}`}
            >
              <span className="font-display font-medium text-xl sm:text-2xl tracking-wide group-hover:text-teal transition-colors">
                {f.q}
              </span>
              <span
                className={`shrink-0 mt-1 w-8 h-8 rounded-full border grid place-items-center transition-all duration-300 ${
                  isOpen ? "border-teal text-teal rotate-45" : "border-line text-mute"
                }`}
              >
                <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">
                  <path d="M7 1v12M1 7h12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
              </span>
            </button>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.45, ease: EASE }}
                  className="overflow-hidden"
                  data-testid={`faq-answer-${i}`}
                >
                  <p className="text-mute leading-relaxed pb-7 pr-10 max-w-3xl">{f.a}</p>
                </motion.div>
              )}
            </AnimatePresence>
          </Reveal>
        );
      })}
    </div>
  );
}
